export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsNo') || '订单产品编号',
    field: 'orderGoodsNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_identifyGoodsNo') || '识别编号',
    field: 'identifyGoodsNo',
    headerAlign: 'center',
    align: 'left',
    width: 230,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.goods_label_orderGoodsName') || '订单产品名称',
    field: 'orderGoodsDisplayName',
    headerAlign: 'center',
    align: 'left',
    width: 380,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_production_order_goods_qty') || '数量',
    field: 'qty',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_packing_inPackageQty') || '装箱入数',
    field: 'inPackageQty',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_production_order_box_qty') || '箱数',
    field: 'boxQty',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
